import type { Action } from "../../actions/types";

export type StoreState = boolean;

export const initialState = false;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_OVERLAY") {
    return action.data === "true";
  }

  return state;
}
